'use client';

import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormWrapper } from '../FormWrapper';
import { RolePicker } from '@/src/components/ui/RolePicker';
import { Button } from '@workspace/ui/components/button';
import { useAuthStore } from '@/src/sections/auth/store/auth-store';
import { ERole } from 'types/src/types';

const schema = z.object({
  roleId: z.nativeEnum(ERole),
});

type FormValues = z.infer<typeof schema>;

export const RoleStep = ({ onNext }: { onNext: () => void }) => {
  const { data, setData } = useAuthStore();

  const { handleSubmit, setValue, watch, reset } = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: { roleId: (data.roleId as ERole) || undefined },
    mode: 'onChange',
  });

  const roleId = watch('roleId');

  useEffect(() => {
    if (roleId !== undefined) setData({ roleId });
  }, [roleId, setData]);

  const onSubmit = (values: FormValues) => {
    setData({ ...values, roleId: values.roleId });
    onNext();
  };

  return (
    <FormWrapper title={['What best', 'describes you?']}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full md:px-10 xl:px-15"
      >
        <RolePicker
          value={roleId}
          onChange={(val: ERole) =>
            setValue('roleId', val, { shouldDirty: true, shouldTouch: true })
          }
          isSmall
        />

        <Button
          className="w-full md:mt-8 mt-5 md:h-[51px] h-10"
          disabled={!roleId}
        >
          Next
        </Button>
      </form>
    </FormWrapper>
  );
};
